module.exports = __webpack_public_path__ + "static/img/notfound.081e71e9.png";